import { useState } from "react";
import {
  addresssCustomerInfoIntialValue as CustomerInfo,
  customerAddressSetup as customer,
} from "../CustomerFormInitialValues";
import {
  CustomerAccountInfo,
  ResponseCustomerEditAccount,
} from "../Customer.types";
import { STATE_REQUIRED } from "../../CountriesProfile/CountriesProfileValidation";

export const CUSTOMER_NAME_REQUIRED = "Customer Name is required";
export const LEADACCOUNT_ID_REQUIRED = "Lead Account ID is required";
export const AUTHORIZED_BUYER_FIRSTNAME_REQUIRED = "First Name is required";
export const AUTHORIZED_BUYER_LASTNAME_REQUIRED = "Last Name is required";
export const AUTHORIZED_BUYER_PHONE_REQUIRED = "Phone is required";
export const AUTHORIZED_BUYER_EMAIL_REQUIRED = "Email is required";
export const STREET_REQUIRED = "Street is required";
export const POSTALCODE_REQUIRED = "Zip/Postal code is required";
export const CITY_REQUIRED = "City is required";
export const PROVINCE_REQUIRED = "State/Province is required";
export const COUNTRY_REQUIRED = "Country is required";
export const BILLINGNAME_REQUIRED = "Billing Name is required";
export const SHIPPINGNAME_REQUIRED = "Shipping Name is required";
export const SPECIAL_CHARACTERS_NOT_ALLOWED =
  "Special Characters like +,~,* not allowed";
export const CHARACTERS_ALLOWED = "Only Characters are allowed";
export const NUMBERS_ALLOWED = "Only Numbers are allowed";
export const LENGTHS_ALLOWED = "Phone Number should contain 10 digits";
export const EMAIL_VALIDATION = "Email should be in correct format";
export const Street_PO_BOX_VALIDATION =
  "Street must not be a P.O Box Or invalid characters";
export const INVALID_PHONENUMBER =
  "Invalid. Length allowed is between 6 to 30 digits";
export const SPECIL_CHARACTER_INVALID_PHONENUMBER =
  "Special Characters like ~,*,- and alphabets not allowed";
export const CHARACTERS_SOME_SPECIAL_CHARACTER_ALLOWED =
  "Special Characters like +,~,* not allowed";
export const SOME_SPECIAL_CHARACTERS_NOT_ALLOWED =
  "Special Characters like +,~,* not allowed";
export const COMPANY_NAME_CHARACTER_LIMIT = "Company Name should not exceed 80 characters";
export const CUSTOMER_NAME_CHARACTER_LIMIT = "Customer Name should not exceed 80 characters";
export const POSTALCODE_CHARACTER_LIMIT = "Postal Code should not exceed 10 characters";
export const CITY_CHARACTER_LIMIT = "City should not exceed 40 characters";
export const CONTACT_FIRSTNAME_CHARACTER_LIMIT = " First name should not exceed 40 characters";
export const CONTACT_LASTNAME_CHARACTER_LIMIT = " Last name should not exceed 40 characters";
export const COMPANY_TAXID_CHARACTER_LIMIT = "Tax id should not exceed 20 characters";
export const EMAIL_CHARACTER_LIMIT = "Email should not exceed 132 characters";
export const CUSTOMER_CERTIFIED_EMAIL_REQUIRED = "Customer Certified Email is required for Italy";
export const CUSTOMER_CONSIGNEE_CODE_REQUIRED = "Customer Consignee Code is required for Italy";
export const BILLING_NAME_CHARACTER_LIMIT="Billing name should not exceed 40 characters";
export const SHIPPING_NAME_CHARACTER_LIMIT=" Billing name should not exceed 40 characters";
export const CONTACT_NAME_CHARACTER_LIMIT = "Name should not exceed 40 Characters"


export const pattern = /^[a-zA-Z0-9 ]+$/;
export const letters = /^[A-Za-z ]+$/;
export const phoneNumberRegex = /^(?:\+[0-9]{5,29}|[0-9]{6,30})$/;
export const contactNumberRegex = /^\+?[0-9]*$/;
export const emailRegex = /^[\w.-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
export const poBoxRegex = /\bP(ost|ostal)?([ \.]*(O|0)(ffice)?)?([ \.]*Box)\b/i;
export const numbersOnly = /^[1-9]\d*$/;
export const taxIdPattern = /^(n\/a|N\/A|[a-zA-Z0-9 ]+)$/;
export const naPattern = /^n\/a$/i;
export const uiTaxIdPattern = /^(n\/a|N\/A|n\/|N\/|[a-zA-Z0-9 ]*)$/i;
export const uiNAPattern = /^(n\/a|N\/A|n\/|N\/|n|N)$/i;
export const allowSpecialCharacterExcludingSome = /^[^\^*|~+\u00AA\u00BA]+$/;
export const allowCharactersAndSpecialSymbols = /^[^\d\^*|~+\u00AA\u00BA]+$/;
export const companyNameCharacterLimit = 80;
export const postalCodeCharacterLimit = 10;
export const cityCharacterLimit = 40;
export const contactNameCharacterLimit = 40;
export const contactPhoneCharacterLimit = 30;
export const emailCharacterLimit = 132;
export const companyTaxIdCharacterLimit = 20;





export const validateCompleteAddCustomerAccountFields = (
  customerAccountInfo: CustomerAccountInfo
) => {
  let customerAccountErrors = CustomerInfo;
  let isValidated = true;

  if (customerAccountInfo?.name.length < 1) {
    customerAccountErrors.name = CUSTOMER_NAME_REQUIRED;
    isValidated = false;
  } else {
    var specialCharacterCustomerName = allowSpecialCharacterExcludingSome.test(
      customerAccountInfo?.name
    );
    if(customerAccountInfo?.name.length > companyNameCharacterLimit){
      customerAccountErrors.name = COMPANY_NAME_CHARACTER_LIMIT;
      isValidated = false;
    }
    else if (specialCharacterCustomerName) {
      customerAccountErrors.name = "";
    } else {
      customerAccountErrors.name = SOME_SPECIAL_CHARACTERS_NOT_ALLOWED;
      isValidated = false;
    }
  }

  if (customerAccountInfo?.registerAddress.registeredtaxId.length > 0) {
    var specialCharacterCustomerTaxId = allowSpecialCharacterExcludingSome.test(
      customerAccountInfo?.registerAddress.registeredtaxId
    );
    if(customerAccountInfo?.registerAddress.registeredtaxId.length > companyTaxIdCharacterLimit){
      customerAccountErrors.registerAddress.registeredtaxId = COMPANY_TAXID_CHARACTER_LIMIT;
      isValidated = false;
    }
    else if (specialCharacterCustomerTaxId) {
      customerAccountErrors.registerAddress.registeredtaxId = "";
    } else {
      customerAccountErrors.registerAddress.registeredtaxId =
        SPECIAL_CHARACTERS_NOT_ALLOWED;
      isValidated = false;
    }
  } else {
    customerAccountErrors.registerAddress.registeredtaxId = "";
  }

  if (customerAccountInfo?.sapAccountId.length > 0) {
    var characterCustomerSapAccountId = numbersOnly.test(
      customerAccountInfo?.sapAccountId
    );
    if (characterCustomerSapAccountId) {
      customerAccountErrors.sapAccountId = "";
    } else {
      customerAccountErrors.sapAccountId = NUMBERS_ALLOWED;
      isValidated = false;
    }
  }
  if (customerAccountInfo?.billingAddress.sapAccountId.length > 0) {
    var characterCustomerSapAccountId = numbersOnly.test(
      customerAccountInfo?.billingAddress.sapAccountId
    );
    if (characterCustomerSapAccountId) {
      customerAccountErrors.billingAddress.sapAccountId = "";
    } else {
      customerAccountErrors.billingAddress.sapAccountId = NUMBERS_ALLOWED;
      isValidated = false;
    }
  }
  if (customerAccountInfo?.shippingAddress.sapAccountId.length > 0) {
    var characterCustomerSapAccountId = numbersOnly.test(
      customerAccountInfo?.shippingAddress.sapAccountId
    );
    if (characterCustomerSapAccountId) {
      customerAccountErrors.shippingAddress.sapAccountId = "";
    } else {
      customerAccountErrors.shippingAddress.sapAccountId = NUMBERS_ALLOWED;
      isValidated = false;
    }
  }

  if (customerAccountInfo?.legalAccountId.length < 1) {
    customerAccountErrors.legalAccountId = LEADACCOUNT_ID_REQUIRED;
    isValidated = false;
  } else {
    customerAccountErrors.legalAccountId = "";
  }
  if (customerAccountInfo?.affilation.length < 1) {
    customerAccountErrors.affilation = "Afflilation is Required";
    isValidated = false;
  } else {
    customerAccountErrors.affilation = "";
  }
  if (customerAccountInfo?.paymentTerms.length < 1) {
    customerAccountErrors.paymentTerms = "Payment Term is Required";
    isValidated = false;
  } else {
    customerAccountErrors.paymentTerms = "";
  }
  if (customerAccountInfo?.authorizedBuyerTitle.length < 1) {
    customerAccountErrors.authorizedBuyerTitle = "Title is Required";
    isValidated = false;
  } else {
    var characterCustomerAuthorizedBuyerTitle =
      allowSpecialCharacterExcludingSome.test(
        customerAccountInfo?.authorizedBuyerTitle
      );
    if (characterCustomerAuthorizedBuyerTitle) {
      customerAccountErrors.authorizedBuyerTitle = "";
    } else {
      customerAccountErrors.authorizedBuyerTitle =
        SPECIAL_CHARACTERS_NOT_ALLOWED;
      isValidated = false;
    }
  }
  if (customerAccountInfo?.authorizedBuyerFirstName.length < 1) {
    customerAccountErrors.authorizedBuyerFirstName =
      AUTHORIZED_BUYER_FIRSTNAME_REQUIRED;
    isValidated = false;
  } else {
    var characterCustomerAuthorizedBuyerFirstName =
      allowSpecialCharacterExcludingSome.test(
        customerAccountInfo?.authorizedBuyerFirstName
      );
    if(customerAccountInfo?.authorizedBuyerFirstName.length > contactNameCharacterLimit){
      customerAccountErrors.authorizedBuyerFirstName = CONTACT_FIRSTNAME_CHARACTER_LIMIT;
      isValidated = false;
    }
    else if (characterCustomerAuthorizedBuyerFirstName) {
      customerAccountErrors.authorizedBuyerFirstName = "";
    } else {
      customerAccountErrors.authorizedBuyerFirstName =
        CHARACTERS_SOME_SPECIAL_CHARACTER_ALLOWED;
      isValidated = false;
    }
  }

  if (customerAccountInfo?.authorizedBuyerLastName.length < 1) {
    customerAccountErrors.authorizedBuyerLastName =
      AUTHORIZED_BUYER_LASTNAME_REQUIRED;
    isValidated = false;
  } else {
    var characterCustomerAuthorizedBuyerLastName =
      allowSpecialCharacterExcludingSome.test(
        customerAccountInfo?.authorizedBuyerLastName
      );
    if(customerAccountInfo?.authorizedBuyerLastName.length > contactNameCharacterLimit){
      customerAccountErrors.authorizedBuyerLastName = CONTACT_LASTNAME_CHARACTER_LIMIT;
      isValidated = false;
    }
    else if (characterCustomerAuthorizedBuyerLastName) {
      customerAccountErrors.authorizedBuyerLastName = "";
    } else {
      customerAccountErrors.authorizedBuyerLastName =
        CHARACTERS_SOME_SPECIAL_CHARACTER_ALLOWED;
      isValidated = false;
    }
  }

  if (customerAccountInfo?.authorizedBuyerPhone.length < 1) {
    customerAccountErrors.authorizedBuyerPhone =
      AUTHORIZED_BUYER_PHONE_REQUIRED;

    isValidated = false;
  } else {
    var characterCustomerAuthorizedBuyerPhone = phoneNumberRegex.test(
      customerAccountInfo?.authorizedBuyerPhone
    );
    if (characterCustomerAuthorizedBuyerPhone) {
      customerAccountErrors.authorizedBuyerPhone = "";
    } else {
      customerAccountErrors.authorizedBuyerPhone = INVALID_PHONENUMBER;
      isValidated = false;
    }
  }

  if (customerAccountInfo?.authorizedEmailId.length < 1) {
    customerAccountErrors.authorizedEmailId = AUTHORIZED_BUYER_EMAIL_REQUIRED;

    isValidated = false;
  } else {
    var emailCustomerAuthorizedEmailId =
      allowSpecialCharacterExcludingSome.test(
        customerAccountInfo?.authorizedEmailId
      );
    var characterCustomerAuthorizedEmailId = emailRegex.test(
      customerAccountInfo?.authorizedEmailId
    );
    if(customerAccountInfo?.authorizedEmailId.length > emailCharacterLimit){
      customerAccountErrors.authorizedEmailId = EMAIL_CHARACTER_LIMIT;
      isValidated = false;
    }
    else if (emailCustomerAuthorizedEmailId) {
      if (characterCustomerAuthorizedEmailId) {
        customerAccountErrors.authorizedEmailId = "";
      } else {
        customerAccountErrors.authorizedEmailId = EMAIL_VALIDATION;
        isValidated = false;
      }
    } else {
      customerAccountErrors.authorizedEmailId =
        SOME_SPECIAL_CHARACTERS_NOT_ALLOWED;
      isValidated = false;
    }
  }

  if (customerAccountInfo?.billingAddress.purchasingCompanyTaxId.length > 0) {
    var specialCharacterCustomerPurchasingCompanyTaxId =
      allowSpecialCharacterExcludingSome.test(
        customerAccountInfo?.billingAddress.purchasingCompanyTaxId
      );
    if(customerAccountInfo?.billingAddress.purchasingCompanyTaxId.length > companyTaxIdCharacterLimit){
      customerAccountErrors.billingAddress.purchasingCompanyTaxId = COMPANY_TAXID_CHARACTER_LIMIT;
      isValidated = false;
    }
    else if (specialCharacterCustomerPurchasingCompanyTaxId) {
      customerAccountErrors.billingAddress.purchasingCompanyTaxId = "";
    } else {
      customerAccountErrors.billingAddress.purchasingCompanyTaxId =
        SPECIAL_CHARACTERS_NOT_ALLOWED;
      isValidated = false;
    }
  } else {
    customerAccountErrors.billingAddress.purchasingCompanyTaxId = "";
  }

  if (customerAccountInfo?.shippingAddress.shipmentCompanyTaxId.length > 0) {
    var specialCharacterCustomershipmentCompanyTaxId =
      allowSpecialCharacterExcludingSome.test(
        customerAccountInfo?.shippingAddress.shipmentCompanyTaxId
      );
    if(customerAccountInfo?.shippingAddress.shipmentCompanyTaxId.length > companyTaxIdCharacterLimit){
      customerAccountErrors.shippingAddress.shipmentCompanyTaxId = COMPANY_TAXID_CHARACTER_LIMIT;
      isValidated = false;
    }
    else if (specialCharacterCustomershipmentCompanyTaxId) {
      customerAccountErrors.shippingAddress.shipmentCompanyTaxId = "";
    } else {
      customerAccountErrors.shippingAddress.shipmentCompanyTaxId =
        SPECIAL_CHARACTERS_NOT_ALLOWED;
      isValidated = false;
    }
  } else {
    customerAccountErrors.shippingAddress.shipmentCompanyTaxId = "";
  }

  if (customerAccountInfo?.registerAddress.street.length < 1) {
    customerAccountErrors.registerAddress.street = STREET_REQUIRED;
    isValidated = false;
  } else {
    var registeredAddressStreetLength =
      customerAccountInfo?.registerAddress.street.length;
    var poBoxRegexStreetPattern = poBoxRegex.test(
      customerAccountInfo?.registerAddress.street
    );
    var poBoxRegexSpecialCharacterStreetPattern =
      allowSpecialCharacterExcludingSome.test(
        customerAccountInfo?.registerAddress.street
      );
    if (registeredAddressStreetLength <= 60) {
      if (poBoxRegexSpecialCharacterStreetPattern) {
        if (poBoxRegexStreetPattern) {
          customerAccountErrors.registerAddress.street =
            Street_PO_BOX_VALIDATION;
          isValidated = false;
        } else {
          customerAccountErrors.registerAddress.street = "";
        }
      } else {
        customerAccountErrors.registerAddress.street =
          SOME_SPECIAL_CHARACTERS_NOT_ALLOWED;
        isValidated = false;
      }
    } else {
      customerAccountErrors.registerAddress.street =
        "Street Length should not be greater than 60 characters";
      isValidated = false;
    }
  }

  if (customerAccountInfo?.registerAddress.postalCode.length < 1) {
    customerAccountErrors.registerAddress.postalCode = POSTALCODE_REQUIRED;
    isValidated = false;
  } else {
    var specialCharacterCustomerPostalCode =
      allowSpecialCharacterExcludingSome.test(
        customerAccountInfo.registerAddress.postalCode
      );
    if(customerAccountInfo?.registerAddress.postalCode.length > postalCodeCharacterLimit){
      customerAccountErrors.registerAddress.postalCode = POSTALCODE_CHARACTER_LIMIT;
      isValidated = false;
    }  
    else if (specialCharacterCustomerPostalCode) {
      customerAccountErrors.registerAddress.postalCode = "";
    } else {
      customerAccountErrors.registerAddress.postalCode =
        SPECIAL_CHARACTERS_NOT_ALLOWED;
      isValidated = false;
    }
  }

  if (customerAccountInfo?.registerAddress.city.length < 1) {
    customerAccountErrors.registerAddress.city = CITY_REQUIRED;
    isValidated = false;
  } else {
    var characterCustomerCity = allowSpecialCharacterExcludingSome.test(
      customerAccountInfo.registerAddress.city
    );
    if(customerAccountInfo?.registerAddress.city.length > cityCharacterLimit){
      customerAccountErrors.registerAddress.city = CITY_CHARACTER_LIMIT;
      isValidated = false;
    }
    else if (characterCustomerCity) {
      customerAccountErrors.registerAddress.city = "";
    } else {
      customerAccountErrors.registerAddress.city =
        CHARACTERS_SOME_SPECIAL_CHARACTER_ALLOWED;
      isValidated = false;
    }
  }

  if (customerAccountInfo?.registerAddress.country.length < 1) {
    customerAccountErrors.registerAddress.country = COUNTRY_REQUIRED;
    isValidated = false;
  } else {
    customerAccountErrors.registerAddress.country = "";
  }
  if (customerAccountInfo?.registerAddress.state.length < 1) {
    customerAccountErrors.registerAddress.state = STATE_REQUIRED;
    isValidated = false;
  } else {
    customerAccountErrors.registerAddress.state = "";
  }
  if (
    customerAccountInfo?.billingAddress.name !== undefined &&
    customerAccountInfo?.billingAddress.name?.length < 1
  ) {
    customerAccountErrors.billingAddress.name = BILLINGNAME_REQUIRED;
    isValidated = false;
  } 
  else {
    if (customerAccountInfo?.billingAddress.name) {
      var specialCharacterCustomerbillingName =
        allowSpecialCharacterExcludingSome.test(
          customerAccountInfo?.billingAddress.name
        );
      if( customerAccountInfo?.billingAddress?.name?.length>customerAccountInfo?.billingAddress?.name?.length){
          customerAccountErrors.billingAddress.name =BILLING_NAME_CHARACTER_LIMIT;
              isValidated = false;
      }
      else if (specialCharacterCustomerbillingName) {
        customerAccountErrors.billingAddress.name = "";
      } else {
        customerAccountErrors.billingAddress.name =
          SOME_SPECIAL_CHARACTERS_NOT_ALLOWED;
        isValidated = false;
      }
    }
  }

  if (customerAccountInfo?.billingAddress.country.length < 1) {
    customerAccountErrors.billingAddress.country = COUNTRY_REQUIRED;
    isValidated = false;
  } else {
    customerAccountErrors.billingAddress.country = "";
  }
  if (customerAccountInfo?.billingAddress.state.length < 1) {
    customerAccountErrors.billingAddress.state = STATE_REQUIRED;
    isValidated = false;
  } else {
    customerAccountErrors.billingAddress.state = "";
  }

  if (customerAccountInfo?.billingAddress.street.length < 1) {
    customerAccountErrors.billingAddress.street = STREET_REQUIRED;
    isValidated = false;
  } else {
    var billingAddressStreetLength =
      customerAccountInfo?.billingAddress.street.length;
    var poBoxRegexStreetPattern = poBoxRegex.test(
      customerAccountInfo?.registerAddress.street
    );
    var poBoxRegexSpecialCharacterStreetPattern =
      allowSpecialCharacterExcludingSome.test(
        customerAccountInfo?.registerAddress.street
      );
    if (billingAddressStreetLength <= 60) {
      if (poBoxRegexSpecialCharacterStreetPattern) {
        if (poBoxRegexStreetPattern) {
          customerAccountErrors.billingAddress.street =
            Street_PO_BOX_VALIDATION;
          isValidated = false;
        } else {
          customerAccountErrors.billingAddress.street = "";
        }
      } else {
        customerAccountErrors.billingAddress.street =
          SOME_SPECIAL_CHARACTERS_NOT_ALLOWED;
        isValidated = false;
      }
    } else {
      customerAccountErrors.billingAddress.street =
        "Street Length should not be greater than 60 characters";
      isValidated = false;
    }
  }

  if (customerAccountInfo?.billingAddress.postalCode.length < 1) {
    customerAccountErrors.billingAddress.postalCode = POSTALCODE_REQUIRED;
    isValidated = false;
  } else {
    var specialCharacterCustomerPostalCode =
      allowSpecialCharacterExcludingSome.test(
        customerAccountInfo?.billingAddress.postalCode
      );
    if(customerAccountInfo?.billingAddress.postalCode.length>postalCodeCharacterLimit){
      customerAccountErrors.billingAddress.postalCode =POSTALCODE_CHARACTER_LIMIT;
      isValidated = false;
    }
    else if (specialCharacterCustomerPostalCode) {
      customerAccountErrors.billingAddress.postalCode = "";
    } else {
      customerAccountErrors.billingAddress.postalCode =
        SPECIAL_CHARACTERS_NOT_ALLOWED;
      isValidated = false;
    }
  }

  if (customerAccountInfo?.billingAddress.city.length < 1) {
    customerAccountErrors.billingAddress.city = CITY_REQUIRED;
    isValidated = false;
  } else {
    var characterCustomerCity = allowSpecialCharacterExcludingSome.test(
      customerAccountInfo?.billingAddress.city
    );
    if(customerAccountInfo?.billingAddress.city.length>cityCharacterLimit){
      customerAccountErrors.billingAddress.city = CITY_CHARACTER_LIMIT;
      isValidated = false;
    }
    else if (characterCustomerCity) {
      customerAccountErrors.billingAddress.city = "";
    } else {
      customerAccountErrors.billingAddress.city =
        CHARACTERS_SOME_SPECIAL_CHARACTER_ALLOWED;
      isValidated = false;
    }
  }

  if (customerAccountInfo?.billingAddress.state.length < 1) {
    customerAccountErrors.billingAddress.state = PROVINCE_REQUIRED;
    isValidated = false;
  } else {
    customerAccountErrors.shippingAddress.state = "";
  }

  if (
    customerAccountInfo?.billingAddress?.contacts?.contactFirstName !==
    undefined &&
    customerAccountInfo?.billingAddress?.contacts.contactFirstName.length < 1
  ) {
    customerAccountErrors.billingAddress.contacts.contactFirstName =
      AUTHORIZED_BUYER_FIRSTNAME_REQUIRED;
    isValidated = false;
  } else {
    if (customerAccountInfo?.billingAddress?.contacts?.contactFirstName) {
      var characterCustomerContactFirstName =
        allowSpecialCharacterExcludingSome.test(
          customerAccountInfo?.billingAddress?.contacts?.contactFirstName
        );
      if(customerAccountInfo?.billingAddress?.contacts?.contactFirstName.length>companyNameCharacterLimit){
        customerAccountErrors.billingAddress.contacts.contactFirstName =CONTACT_FIRSTNAME_CHARACTER_LIMIT;
        isValidated = false;
      } 
      else if (characterCustomerContactFirstName) {
        customerAccountErrors.billingAddress.contacts.contactFirstName = "";
      } else {
        customerAccountErrors.billingAddress.contacts.contactFirstName =
          CHARACTERS_SOME_SPECIAL_CHARACTER_ALLOWED;
        isValidated = false;
      }
    }
  }

  if (
    customerAccountInfo?.billingAddress?.contacts?.contactLastName !==
    undefined &&
    customerAccountInfo?.billingAddress?.contacts.contactLastName.length < 1
  ) {
    customerAccountErrors.billingAddress.contacts.contactLastName =
      AUTHORIZED_BUYER_LASTNAME_REQUIRED;
    isValidated = false;
  } else {
    if (customerAccountInfo?.billingAddress?.contacts?.contactLastName) {
      var characterCustomerContactLastName =
        allowSpecialCharacterExcludingSome.test(
          customerAccountInfo?.billingAddress?.contacts.contactLastName
        );
      if(customerAccountInfo?.billingAddress?.contacts?.contactLastName?.length>contactNameCharacterLimit){
        customerAccountErrors.billingAddress.contacts.contactLastName = CONTACT_LASTNAME_CHARACTER_LIMIT;
        isValidated = false;
      }
      else if (characterCustomerContactLastName) {
        customerAccountErrors.billingAddress.contacts.contactLastName = "";
      } else {
        customerAccountErrors.billingAddress.contacts.contactLastName =
          CHARACTERS_SOME_SPECIAL_CHARACTER_ALLOWED;
        isValidated = false;
      }
    }
  }

  if (
    customerAccountInfo?.billingAddress?.contacts?.contactPhone !== undefined &&
    customerAccountInfo?.billingAddress?.contacts.contactPhone.length < 1
  ) {
    customerAccountErrors.billingAddress.contacts.contactPhone =
      AUTHORIZED_BUYER_PHONE_REQUIRED;
    isValidated = false;
  } else {
    if (customerAccountInfo?.billingAddress?.contacts?.contactPhone) {
      var characterCustomerContactPhone = phoneNumberRegex.test(
        customerAccountInfo?.billingAddress?.contacts.contactPhone
      );
      if (characterCustomerContactPhone) {
        customerAccountErrors.billingAddress.contacts.contactPhone = "";
      } else {
        customerAccountErrors.billingAddress.contacts.contactPhone =
          INVALID_PHONENUMBER;
        isValidated = false;
      }
    }
  }

  if (
    customerAccountInfo?.billingAddress?.contacts?.contactEmail !== undefined &&
    customerAccountInfo?.billingAddress?.contacts.contactEmail.length < 1
  ) {
    customerAccountErrors.billingAddress.contacts.contactEmail =
      AUTHORIZED_BUYER_EMAIL_REQUIRED;
    isValidated = false;
  } else {
    if (customerAccountInfo?.billingAddress?.contacts?.contactEmail) {
      var emailCustomerAuthorizedEmailId =
        allowSpecialCharacterExcludingSome.test(
          customerAccountInfo?.billingAddress?.contacts.contactEmail
        );
      var characterCustomerAuthorizedEmailId = emailRegex.test(
        customerAccountInfo?.billingAddress?.contacts.contactEmail
      );
      if(customerAccountInfo?.billingAddress?.contacts?.contactEmail?.length>emailCharacterLimit){
        customerAccountErrors.billingAddress.contacts.contactEmail = EMAIL_CHARACTER_LIMIT;
          isValidated = false;
      }
      else if (emailCustomerAuthorizedEmailId) {
        if (characterCustomerAuthorizedEmailId) {
          customerAccountErrors.billingAddress.contacts.contactEmail = "";
        } else {
          customerAccountErrors.billingAddress.contacts.contactEmail =
            EMAIL_VALIDATION;
          isValidated = false;
        }
      } else {
        customerAccountErrors.billingAddress.contacts.contactEmail =
          SOME_SPECIAL_CHARACTERS_NOT_ALLOWED;
        isValidated = false;
      }
    }
  }
  if(customerAccountInfo?.registerAddress?.customerCertifiedEmail){
    if(customerAccountInfo?.registerAddress?.customerCertifiedEmail?.length>emailCharacterLimit){
      customerAccountErrors.registerAddress.customerCertifiedEmail = EMAIL_CHARACTER_LIMIT;
      isValidated = false;
    }
    else if(emailRegex.test(customerAccountInfo?.registerAddress?.customerCertifiedEmail)){
      customerAccountErrors.registerAddress.customerCertifiedEmail = "";
    }else{
      customerAccountErrors.registerAddress.customerCertifiedEmail = EMAIL_VALIDATION;
      isValidated = false;
    }
  }

  // Check if Customer Certified Email is mandatory for Italy
  if (customerAccountInfo?.registerAddress?.country?.toLowerCase() === "italy") {
    if (!customerAccountInfo?.registerAddress?.customerCertifiedEmail || 
        customerAccountInfo?.registerAddress?.customerCertifiedEmail?.trim() === "") {
      customerAccountErrors.registerAddress.customerCertifiedEmail = CUSTOMER_CERTIFIED_EMAIL_REQUIRED;
      isValidated = false;
    }
  } else {
    // Clear the error if country is not Italy
    customerAccountErrors.registerAddress.customerCertifiedEmail = "";
  }

  // Check if Customer Consignee Code is mandatory for Italy
  if (customerAccountInfo?.registerAddress?.country?.toLowerCase() === "italy") {
    if (!customerAccountInfo?.registerAddress?.customerConsigneeCode || 
        customerAccountInfo?.registerAddress?.customerConsigneeCode?.trim() === "") {
      customerAccountErrors.registerAddress.customerConsigneeCode = CUSTOMER_CONSIGNEE_CODE_REQUIRED;
      isValidated = false;
    }
  } else {
    // Clear the error if country is not Italy
    customerAccountErrors.registerAddress.customerConsigneeCode = "";
  }

  // Shipping Address Validation

  if (
    customerAccountInfo?.shippingAddress?.name !== undefined &&
    customerAccountInfo?.shippingAddress.name?.length < 1
  ) {
    customerAccountErrors.shippingAddress.name = SHIPPINGNAME_REQUIRED;
    isValidated = false;
  } else {
    if (customerAccountInfo?.shippingAddress.name) {
      var specialCharacterCustomerShippingName =
        allowSpecialCharacterExcludingSome.test(
          customerAccountInfo?.shippingAddress.name
        );
      if(customerAccountInfo?.shippingAddress.name?.length>companyNameCharacterLimit){
        customerAccountErrors.shippingAddress.name = SHIPPING_NAME_CHARACTER_LIMIT;
        isValidated = false;
      }
      if (specialCharacterCustomerShippingName) {
        customerAccountErrors.shippingAddress.name = "";
      } else {
        customerAccountErrors.shippingAddress.name =
          SOME_SPECIAL_CHARACTERS_NOT_ALLOWED;
        isValidated = false;
      }
    }
  }

  if (customerAccountInfo?.shippingAddress.street.length < 1) {
    customerAccountErrors.shippingAddress.street = STREET_REQUIRED;
    isValidated = false;
  } else {
    var specialAddressLength =
      customerAccountInfo?.shippingAddress.street.length;
    var poBoxRegexStreetPattern = poBoxRegex.test(
      customerAccountInfo?.registerAddress.street
    );
    var poBoxRegexSpecialCharacterStreetPattern =
      allowSpecialCharacterExcludingSome.test(
        customerAccountInfo?.registerAddress.street
      );

    if (specialAddressLength <= 60) {
      if (poBoxRegexSpecialCharacterStreetPattern) {
        if (poBoxRegexStreetPattern) {
          customerAccountErrors.shippingAddress.street =
            Street_PO_BOX_VALIDATION;
          isValidated = false;
        } else {
          customerAccountErrors.shippingAddress.street = "";
        }
      } else {
        customerAccountErrors.shippingAddress.street =
          SOME_SPECIAL_CHARACTERS_NOT_ALLOWED;
        isValidated = false;
      }
    } else {
      customerAccountErrors.shippingAddress.street =
        "Street Length should not be greater than 60 characters";
      isValidated = false;
    }
  }

  if (customerAccountInfo?.shippingAddress.postalCode.length < 1) {
    customerAccountErrors.shippingAddress.postalCode = POSTALCODE_REQUIRED;
    isValidated = false;
  } else {
    var specialCharacterCustomerPostalCode =
      allowSpecialCharacterExcludingSome.test(
        customerAccountInfo?.shippingAddress.postalCode
      );
    if(customerAccountInfo?.shippingAddress.postalCode.length>postalCodeCharacterLimit){
      customerAccountErrors.shippingAddress.postalCode = POSTALCODE_CHARACTER_LIMIT;
      isValidated = false;
    }    
    else if (specialCharacterCustomerPostalCode) {
      customerAccountErrors.shippingAddress.postalCode = "";
    } else {
      customerAccountErrors.shippingAddress.postalCode =
        SPECIAL_CHARACTERS_NOT_ALLOWED;
      isValidated = false;
    }
  }

  if (customerAccountInfo?.shippingAddress.city.length < 1) {
    customerAccountErrors.shippingAddress.city = CITY_REQUIRED;
    isValidated = false;
  } else {
    var characterCustomerCity = allowSpecialCharacterExcludingSome.test(
      customerAccountInfo?.shippingAddress.city
    );
    if(customerAccountInfo?.shippingAddress.city.length>cityCharacterLimit){
      customerAccountErrors.shippingAddress.city = CITY_CHARACTER_LIMIT;
      isValidated = false;
    }
   else  if (characterCustomerCity) {
      customerAccountErrors.shippingAddress.city = "";
    } else {
      customerAccountErrors.shippingAddress.city =
        CHARACTERS_SOME_SPECIAL_CHARACTER_ALLOWED;
      isValidated = false;
    }
  }

  if (customerAccountInfo?.shippingAddress.state.length < 1) {
    customerAccountErrors.shippingAddress.state = PROVINCE_REQUIRED;
    isValidated = false;
  } else {
    customerAccountErrors.shippingAddress.state = "";
  }

  if (customerAccountInfo?.shippingAddress.country.length < 1) {
    customerAccountErrors.shippingAddress.country = COUNTRY_REQUIRED;
    isValidated = false;
  } else {
    customerAccountErrors.shippingAddress.country = "";
  }
  if (customerAccountInfo?.shippingAddress.state.length < 1) {
    customerAccountErrors.shippingAddress.state = STATE_REQUIRED;
    isValidated = false;
  } else {
    customerAccountErrors.shippingAddress.state = "";
  }

  if (
    customerAccountInfo?.shippingAddress?.contacts?.contactFirstName !==
    undefined &&
    customerAccountInfo?.shippingAddress?.contacts?.contactFirstName.length < 1
  ) {
    customerAccountErrors.shippingAddress.contacts.contactFirstName =
      AUTHORIZED_BUYER_FIRSTNAME_REQUIRED;
    isValidated = false;
  } else {
    if (customerAccountInfo?.shippingAddress?.contacts?.contactFirstName) {
      var characterCustomerContactFirstName =
        allowSpecialCharacterExcludingSome.test(
          customerAccountInfo?.shippingAddress?.contacts.contactFirstName
        );
      if(customerAccountInfo?.shippingAddress?.contacts?.contactFirstName.length>contactNameCharacterLimit){
        customerAccountErrors.shippingAddress.contacts.contactFirstName = CONTACT_FIRSTNAME_CHARACTER_LIMIT;
        isValidated = false;
      }
      else if (characterCustomerContactFirstName) {
        customerAccountErrors.shippingAddress.contacts.contactFirstName = "";
      } else {
        customerAccountErrors.shippingAddress.contacts.contactFirstName =
          CHARACTERS_SOME_SPECIAL_CHARACTER_ALLOWED;
        isValidated = false;
      }
    }
  }

  if (
    customerAccountInfo?.shippingAddress?.contacts?.contactLastName !==
    undefined &&
    customerAccountInfo?.shippingAddress?.contacts.contactLastName.length < 1
  ) {
    customerAccountErrors.shippingAddress.contacts.contactLastName =
      AUTHORIZED_BUYER_LASTNAME_REQUIRED;
    isValidated = false;
  } else {
    if (customerAccountInfo?.shippingAddress?.contacts?.contactLastName) {
      var characterCustomerContactLastName =
        allowSpecialCharacterExcludingSome.test(
          customerAccountInfo?.shippingAddress?.contacts?.contactLastName
        );
      if(customerAccountInfo?.shippingAddress?.contacts?.contactLastName.length>contactNameCharacterLimit){
        customerAccountErrors.shippingAddress.contacts.contactLastName = CONTACT_LASTNAME_CHARACTER_LIMIT;
        isValidated = false;
      }
      else if (characterCustomerContactLastName) {
        customerAccountErrors.shippingAddress.contacts.contactLastName = "";
      } else {
        customerAccountErrors.shippingAddress.contacts.contactLastName =
          CHARACTERS_SOME_SPECIAL_CHARACTER_ALLOWED;
        isValidated = false;
      }
    }
  }

  if (
    customerAccountInfo?.shippingAddress?.contacts?.contactPhone !==
    undefined &&
    customerAccountInfo?.shippingAddress?.contacts.contactPhone.length < 1
  ) {
    customerAccountErrors.shippingAddress.contacts.contactPhone =
      AUTHORIZED_BUYER_PHONE_REQUIRED;
    isValidated = false;
  } else {
    if (customerAccountInfo?.shippingAddress?.contacts?.contactPhone) {
      var characterCustomerContactPhone = phoneNumberRegex.test(
        customerAccountInfo?.shippingAddress?.contacts.contactPhone
      );
      if (characterCustomerContactPhone) {
        customerAccountErrors.shippingAddress.contacts.contactPhone = "";
      } else {
        customerAccountErrors.shippingAddress.contacts.contactPhone =
          NUMBERS_ALLOWED;
        isValidated = false;
      }
    }
  }

  if (
    customerAccountInfo?.shippingAddress?.contacts?.contactEmail !==
    undefined &&
    customerAccountInfo?.shippingAddress?.contacts.contactEmail.length < 1
  ) {
    customerAccountErrors.shippingAddress.contacts.contactEmail =
      AUTHORIZED_BUYER_EMAIL_REQUIRED;
    isValidated = false;
  } else {
    if (customerAccountInfo?.shippingAddress?.contacts?.contactEmail) {
      var emailCustomerAuthorizedEmailId =
        allowSpecialCharacterExcludingSome.test(
          customerAccountInfo?.shippingAddress?.contacts.contactEmail
        );
      var characterCustomerAuthorizedEmailId = emailRegex.test(
        customerAccountInfo?.shippingAddress?.contacts.contactEmail
      );
      if(customerAccountInfo?.shippingAddress?.contacts?.contactEmail.length>emailCharacterLimit){
        customerAccountErrors.shippingAddress.contacts.contactEmail =
          EMAIL_CHARACTER_LIMIT;
        isValidated = false;
      }
      if (emailCustomerAuthorizedEmailId) {
        if (characterCustomerAuthorizedEmailId) {
          customerAccountErrors.shippingAddress.contacts.contactEmail = "";
        } else {
          customerAccountErrors.shippingAddress.contacts.contactEmail =
            EMAIL_VALIDATION;
          isValidated = false;
        }
      } else {
        customerAccountErrors.shippingAddress.contacts.contactEmail =
          SOME_SPECIAL_CHARACTERS_NOT_ALLOWED;
        isValidated = false;
      }
    }
  }

  // Fapio Address Validation

  if (customerAccountInfo.billingAddress.country.toUpperCase() === "CHINA") {
    if (
      customerAccountInfo?.fapiaoAddress?.name !== undefined &&
      customerAccountInfo?.fapiaoAddress.name?.length < 1
    ) {
      customerAccountErrors.fapiaoAddress.name = "Name is Required";
      isValidated = false;
    } else {
      if (customerAccountInfo?.fapiaoAddress.name) {
        var specialCharacterCustomerShippingName =
          allowSpecialCharacterExcludingSome.test(
            customerAccountInfo?.fapiaoAddress.name
          );
        if(customerAccountInfo?.fapiaoAddress.name.length>contactNameCharacterLimit){
          customerAccountErrors.fapiaoAddress.name = CONTACT_NAME_CHARACTER_LIMIT;
          isValidated = false;
        }
        
        else if (specialCharacterCustomerShippingName) {
          customerAccountErrors.fapiaoAddress.name = "";
        } else {
          customerAccountErrors.fapiaoAddress.name =
            SPECIAL_CHARACTERS_NOT_ALLOWED;
          isValidated = false;
        }
      }
    }

    if (customerAccountInfo?.fapiaoAddress.street.length < 1) {
      customerAccountErrors.fapiaoAddress.street = STREET_REQUIRED;
      isValidated = false;
    } else {
      var fapiaoAddressStreetLength =
        customerAccountInfo?.fapiaoAddress.street.length;
      if (fapiaoAddressStreetLength <= 60) {
        customerAccountErrors.fapiaoAddress.street = "";
      } else {
        customerAccountErrors.fapiaoAddress.street =
          "Street Length should not be greater than 60 characters";
        isValidated = false;
      }
    }

    if (customerAccountInfo?.fapiaoAddress.postalCode.length < 1) {
      customerAccountErrors.fapiaoAddress.postalCode = POSTALCODE_REQUIRED;
      isValidated = false;
    } else {
      var specialCharacterCustomerPostalCode = pattern.test(
        customerAccountInfo?.fapiaoAddress.postalCode
      );
      if(customerAccountInfo?.fapiaoAddress.postalCode.length>postalCodeCharacterLimit){
        customerAccountErrors.fapiaoAddress.postalCode = POSTALCODE_CHARACTER_LIMIT;
        isValidated = false;
      }
      else if (specialCharacterCustomerPostalCode) {
        customerAccountErrors.fapiaoAddress.postalCode = "";
      } else {
        customerAccountErrors.fapiaoAddress.postalCode =
          SPECIAL_CHARACTERS_NOT_ALLOWED;
        isValidated = false;
      }
    }

    if (customerAccountInfo?.fapiaoAddress.city.length < 1) {
      customerAccountErrors.fapiaoAddress.city = CITY_REQUIRED;
      isValidated = false;
    } else {
      var characterCustomerCity = allowCharactersAndSpecialSymbols.test(
        customerAccountInfo?.fapiaoAddress.city
      );
      if(customerAccountInfo?.fapiaoAddress.city.length>cityCharacterLimit){
        customerAccountErrors.fapiaoAddress.city = POSTALCODE_CHARACTER_LIMIT;
      isValidated = false;
      }
      if (characterCustomerCity) {
        customerAccountErrors.fapiaoAddress.city = "";
      } else {
        customerAccountErrors.fapiaoAddress.city =
          CHARACTERS_SOME_SPECIAL_CHARACTER_ALLOWED;
        isValidated = false;
      }
    }

    if (customerAccountInfo?.fapiaoAddress.state.length < 1) {
      customerAccountErrors.fapiaoAddress.state = PROVINCE_REQUIRED;
      isValidated = false;
    } else {
      customerAccountErrors.shippingAddress.state = "";
    }

    if (customerAccountInfo?.fapiaoAddress.country.length < 1) {
      customerAccountErrors.fapiaoAddress.country = COUNTRY_REQUIRED;
      isValidated = false;
    } else {
      var characterCustomerCountry = letters.test(
        customerAccountInfo?.fapiaoAddress.country
      );
      if (characterCustomerCountry) {
        customerAccountErrors.fapiaoAddress.country = "";
      } else {
        customerAccountErrors.fapiaoAddress.country = CHARACTERS_ALLOWED;
        isValidated = false;
      }
    }

    if (customerAccountInfo?.fapiaoAddress.country.length < 1) {
      customerAccountErrors.fapiaoAddress.country = COUNTRY_REQUIRED;
      isValidated = false;
    } else {
      customerAccountErrors.fapiaoAddress.country = "";
    }
    if (customerAccountInfo?.fapiaoAddress.state.length < 1) {
      customerAccountErrors.fapiaoAddress.state = STATE_REQUIRED;
      isValidated = false;
    } else {
      customerAccountErrors.fapiaoAddress.state = "";
    }

    if (
      customerAccountInfo?.fapiaoAddress?.contacts?.contactPhone !==
      undefined &&
      customerAccountInfo?.fapiaoAddress?.contacts.contactPhone.length < 1
    ) {
      customerAccountErrors.fapiaoAddress.contacts.contactPhone =
        AUTHORIZED_BUYER_PHONE_REQUIRED;
      isValidated = false;
    } else {
      if (customerAccountInfo?.fapiaoAddress?.contacts?.contactPhone) {
        var characterCustomerContactPhone = phoneNumberRegex.test(
          customerAccountInfo?.fapiaoAddress?.contacts.contactPhone
        );
        if (characterCustomerContactPhone) {
          customerAccountErrors.fapiaoAddress.contacts.contactPhone = "";
        } else {
          customerAccountErrors.fapiaoAddress.contacts.contactPhone =
            NUMBERS_ALLOWED;
          isValidated = false;
        }
      }
    }
  }

  return { isValidated, customerAccountErrors };
};
